<!--
 * @Author: your name
 * @Date: 2022-04-27 09:17:45
 * @LastEditTime: 2025-03-12 08:49:52
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jzjy\src\views\Dashboard\index.vue
-->
<template>
  <div id="container">
    <div class="bigBanner">
      <div class="banner">
        <el-carousel height="480px">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img
              :src="item.file_url"
              alt="banner图"
              @click="advert(item.http_url,item.id)"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 教研活动 -->
    <div class="jyactive" >
      <div class="boxtitle">
        <div class="left">
          <h4>教研活动</h4>
        </div>
        <div class="right" @click="goActiveCenter">查看更多</div>
      </div>
      <div class="activeList">
        <div
          class="activeBox"
          v-for="item in activeList"
          :key="item.id"
          @click="goActiveDetails(item.id,item.http_type,item.cs3)"
        >
          <div class="tips" v-if="item.zb_status == 1"><p>预约中</p></div>
          <div class="tips zbz" v-if="item.zb_status == 2"><img src="../../assets/img/5.0/newActive (10).png" alt=""><p>直播中</p></div>
          <div class="pic">
            <img :src="item.file_url" />
          </div>
          <div class="activetitle">
            <p>{{ item.title }}</p>
          </div>
          <div class="teacherName">
            主讲专家：{{item.teacher_title}}
          </div>
          <div class="activetime">
            {{ timeStamp2String(item.start_time * 1000, 2) }}
            {{ timeStamp2String(item.start_time * 1000, 5) }}（{{
              timeStamp2String(item.start_time * 1000, 11)
            }}）
          </div>
          <div
            class="dosome bm"
            style="background: #1e60eb;"
            v-if="
              item.bm_status == 0 && new Date().getTime() < item.end_time * 1000
            "
          >
            预约
          </div>
          <div
            class="dosome bm"
            v-if="
              item.bm_status == 1 && new Date().getTime() < item.end_time * 1000
            "
          >
            已预约
          </div>
          <div
              class="dosome zhibo"
              style="background: #F05659;"
              v-if="
                item.bm_status == 1 &&
                new Date().getTime()> item.start_time * 1000
                 && new Date().getTime() <
                  item.end_time * 1000
              "
            >
              进入直播
            </div>
          <div
            class="dosome huifang"
            v-if="new Date().getTime() > item.end_time * 1000"
          >
            查看回放
          </div>
          <div
            class="dosome huifang"
            v-if="new Date().getTime() > item.end_time * 1000 && item.have_video == 0" 
          >
            暂无回放
          </div>
        </div>
        <div class="seemoreactive">
          <img src="../../assets/img/4.2/indexacpic.png" alt="" />
          <div class="gomoreactive" @click="goActiveCenter">
            查看更多精彩活动
          </div>
        </div>
      </div>
    </div>
    <!-- 合作名师 -->
    <div class="teschers" >
      <div class="boxtitle">
        <div class="left">
          <h4>合作名师</h4>
        </div>
        <div class="right" @click="goMsCenter" v-if="false">查看更多</div>
      </div>
      <div class="recommend">
        <div class="tecLists">
          <div class="tecSwiper">
            <div class="teacherLists" ref="tecsList">
              <div
                class="box"
                v-for="(item,index) in teacherLists.concat(teacherLists.slice(0, 8))"
                :key="index"
              >
                <div class="pic">
                  <img :src="item.file_url" />
                </div>
                <h3>{{ item.title }}</h3>
                <h4>{{item.zhicheng}}</h4>
                <p>{{ item.sub_title  }}</p>
              </div>
            </div>
            <span class="leftN anniu" @click="tecLeft"
              ><i class="el-icon-arrow-left"></i
            ></span>
            <span class="rightN anniu" @click="tecRight"
              ><i class="el-icon-arrow-right"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="gongzuoshi" v-if="false">
        <div class="gzsBox" v-for="item in msLists" :key="item.id">
          <div class="left" @click="gomsDetails(item.id)">
            <div class="pic">
              <img :src="item.file_url" alt="">
            </div>
            <div class="msg">
              <h4>{{item.title}}</h4>
              <p>{{item.sub_title}}</p>
              <div class="zylj">资源累计：<span>{{item.res_num}}份</span></div>
            </div>
            <div class="tip" v-if="item.versions_title">{{item.versions_title}}</div>
          </div>
          <div class="right">
            <div class="fileList" v-for="list in item.tj_res_list.slice(0, 2)" :key="list.id"  @click="goresDetails(list.row_id, '', list.suffix)">
              <div class="pic">
                <img
                  src="../../assets/img/resFile (1).png"
                  alt="file_url"
                  v-if="
                    list.suffix == 'ppt' ||
                    list.suffix == 'pptx' ||
                    list.suffix == 'ppsx' ||
                    list.suffix == 'pps'
                  "
                />
                <img
                  src="../../assets/img/resFile (2).png"
                  alt="file_url"
                  v-if="list.suffix == 'mp4' || list.suffix == 'rm'"
                />
                <img
                  src="../../assets/img/resFile (3).png"
                  alt="file_url"
                  v-if="list.suffix == 'xls' || list.suffix == 'xlsx'"
                />
                <img
                  src="../../assets/img/resFile (4).png"
                  alt="file_url"
                  v-if="list.suffix == 'zip' || list.suffix == 'rar'"
                />
                <img
                  src="../../assets/img/resFile (5).png"
                  alt="file_url"
                  v-if="list.suffix == 'm4a' || list.suffix == 'mp3'"
                />
                <img
                  src="../../assets/img/resFile (6).png"
                  alt="file_url"
                  v-if="list.suffix == 'doc' || list.suffix == 'docx'"
                />
                <img
                  src="../../assets/img/resFile (7).png"
                  alt="file_url"
                  v-if="list.suffix == 'pdf'"
                />
                <img
                  src="../../assets/img/resFile (8).png"
                  alt="file_url"
                  v-if="list.suffix == 'png' || list.suffix == 'jpg'"
                />
              </div>
              <div class="msg">
                <h4>{{list.row_title}}</h4>
                <p>{{timeStamp2String(list.create_time*1000,2)}}</p>
              </div>
            </div>
            <p @click="gomsDetails(item.id)">查看全部</p>
          </div>
        </div>
      </div>
      <div class="msBanner" @click="gomsrz">
        <div class="pic">
          <img src="../../assets/img/5.0/img01.png" alt="">
        </div>
        <div class="msru">申请入驻</div>
      </div>
    </div>
    <!-- 资源推荐 -->
    <div class="ziyuanTj" >
      <div class="boxtitle">
        <div class="left">
          <h4>资源推荐</h4>
        </div>
        <div class="right" @click="goTb">查看更多</div>
      </div>
      <div class="tjBox">
        <div class="left">
          <div class="banner">
            <el-carousel height="304px">
              <el-carousel-item v-for="(item, index) in bannerList2" :key="index" >
                <img :src="item.file_url" @click="bannerGo(item.http_url)"/>
                <h2 @click="bannerGo(item.http_url)">{{item.sub_title}}</h2>
                <!-- <p>更新于{{item.beizhu}}</p> -->
                <p @click="bannerGo(item.http_url)">立即查看>>>></p>
              </el-carousel-item>
              
            </el-carousel>
            
            <!-- <p v-if="tjFileMsg.time">更新于{{timeStamp2String(tjFileMsg.time*1000,2)}}</p> -->
          </div>
        </div>
        <div class="right">
          <div class="zyLists" v-for="item in tjzyLists" :key="item.id">
            <div class="left">
              <h2>{{timeStamp2String(item.update_time*1000,17)}}</h2>
              <p>{{timeStamp2String(item.update_time*1000,3)}}</p>
            </div>
            <div class="zyright" @click="goresDetails(item.id, '', item.suffix)">
              <div class="pic">
                <img
                  src="../../assets/img/resFile (1).png"
                  alt="file_url"
                  v-if="
                    item.suffix == 'ppt' ||
                    item.suffix == 'pptx' ||
                    item.suffix == 'ppsx' ||
                    item.suffix == 'pps'
                  "
                />
                <img
                  src="../../assets/img/resFile (2).png"
                  alt="file_url"
                  v-if="item.suffix == 'mp4' || item.suffix == 'rm'"
                />
                <img
                  src="../../assets/img/resFile (3).png"
                  alt="file_url"
                  v-if="item.suffix == 'xls' || item.suffix == 'xlsx'"
                />
                <img
                  src="../../assets/img/resFile (4).png"
                  alt="file_url"
                  v-if="item.suffix == 'zip' || item.suffix == 'rar'"
                />
                <img
                  src="../../assets/img/resFile (5).png"
                  alt="file_url"
                  v-if="item.suffix == 'm4a' || item.suffix == 'mp3'"
                />
                <img
                  src="../../assets/img/resFile (6).png"
                  alt="file_url"
                  v-if="item.suffix == 'doc' || item.suffix == 'docx'"
                />
                <img
                  src="../../assets/img/resFile (7).png"
                  alt="file_url"
                  v-if="item.suffix == 'pdf'"
                />
                <img
                  src="../../assets/img/resFile (8).png"
                  alt="file_url"
                  v-if="item.suffix == 'png' || item.suffix == 'jpg'"
                />
              </div>
              <div class="msg">
                <h4>{{item.title}}</h4>
              </div>
              <p>查看</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 首页新增最新资源和最新试卷 -->
      <div class="ziyuan">
        <div class="newziyuan">
          <div class="boxtitle">
            <div class="left">
              <h4>最新资源</h4>
              <span>NEW</span>
            </div>
            <div class="right" @click="gotobu">查看更多</div>
          </div>
          <div class="ziyuancontent">
            <div
              class="ziyuanLists"
              v-for="item in newLists"
              :key="item.id"
              @click="goresDetails(item.id, item.lx, item.suffix)"
            >
              <img
                src="../../assets/img/ziyuan.png"
                v-if="item.lx == 2"
                style="height: 74px"
              />
              <img
                src="../../assets/img/resFile (1).png"
                alt="file_url"
                v-if="
                  item.suffix == 'ppt' ||
                  item.suffix == 'pptx' ||
                  item.suffix == 'ppsx' ||
                  item.suffix == 'pps'
                "
              />
              <img
                src="../../assets/img/resFile (2).png"
                alt="file_url"
                v-if="item.suffix == 'mp4' || item.suffix == 'rm'"
              />
              <img
                src="../../assets/img/resFile (3).png"
                alt="file_url"
                v-if="item.suffix == 'xls' || item.suffix == 'xlsx'"
              />
              <img
                src="../../assets/img/resFile (4).png"
                alt="file_url"
                v-if="item.suffix == 'zip' || item.suffix == 'rar'"
              />
              <img
                src="../../assets/img/resFile (5).png"
                alt="file_url"
                v-if="item.suffix == 'm4a' || item.suffix == 'mp3'"
              />
              <img
                src="../../assets/img/resFile (6).png"
                alt="file_url"
                v-if="item.suffix == 'doc' || item.suffix == 'docx'"
              />
              <img
                src="../../assets/img/resFile (7).png"
                alt="file_url"
                v-if="item.suffix == 'pdf'"
              />
              <img
                src="../../assets/img/resFile (8).png"
                alt="file_url"
                v-if="item.suffix == 'png' || item.suffix == 'jpg'"
              />
              <p>
                {{ item.title }}
              </p>
              <div class="zytime">
                {{ timeStamp2String(item.create_time * 1000, 2) }}
              </div>
            </div>
          </div>
        </div>
        <div class="newziyuan">
          <div class="boxtitle">
            <div class="left">
              <h4>最新试卷</h4>
              <span>NEW</span>
            </div>
            <div class="right" @click="sjseemore">查看更多</div>
          </div>
          <div class="ziyuancontent">
            <div
              class="ziyuanLists"
              v-for="item in newshijuanLists"
              :key="item.id"
              @click="goresDetails(item.id, item.lx, item.suffix)"
            >
              <img
                src="../../assets/img/ziyuan.png"
                v-if="item.lx == 2"
                style="height: 74px"
              />
              <img
                src="../../assets/img/resFile (1).png"
                alt="file_url"
                v-if="
                  item.suffix == 'ppt' ||
                  item.suffix == 'pptx' ||
                  item.suffix == 'ppsx' ||
                  item.suffix == 'pps'
                "
              />
              <img
                src="../../assets/img/resFile (2).png"
                alt="file_url"
                v-if="item.suffix == 'mp4' || item.suffix == 'rm'"
              />
              <img
                src="../../assets/img/resFile (3).png"
                alt="file_url"
                v-if="item.suffix == 'xls' || item.suffix == 'xlsx'"
              />
              <img
                src="../../assets/img/resFile (4).png"
                alt="file_url"
                v-if="item.suffix == 'zip' || item.suffix == 'rar'"
              />
              <img
                src="../../assets/img/resFile (5).png"
                alt="file_url"
                v-if="item.suffix == 'm4a' || item.suffix == 'mp3'"
              />
              <img
                src="../../assets/img/resFile (6).png"
                alt="file_url"
                v-if="item.suffix == 'doc' || item.suffix == 'docx'"
              />
              <img
                src="../../assets/img/resFile (7).png"
                alt="file_url"
                v-if="item.suffix == 'pdf'"
              />
              <img
                src="../../assets/img/resFile (8).png"
                alt="file_url"
                v-if="item.suffix == 'png' || item.suffix == 'jpg'"
              />
              <p>
                {{ item.title }}
              </p>
              <div class="zytime">
                {{ timeStamp2String(item.create_time * 1000, 2) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product" v-show="booklist.length != 0">
        <div class="boxtitle">
          <div class="left">
            <h4>参考资料推荐</h4>
          </div>
          <div class="right" @click="goResourceCenter">查看更多</div>
        </div>
        <div class="recommend">
          <div class="jiaofuBooks">
            <div class="tips">
              <img src="../../assets/img/5.0/img03.png" alt="">
              <!-- <h2>为你精选</h2>
            <p>教辅图书</p> -->
            </div>
            <div class="bookSwiper">
              <div class="booksList" ref="booksList">
                <div
                  class="box"
                  v-for="item in booklist"
                  :key="item.id"
                  @click="productDetails(item.id, item.type_id)"
                >
                  <div class="pic">
                    <img :src="item.file_url" />
                  </div>
                  <h4>{{ item.title }}</h4>
                  <!-- <p>权威编者：{{ item.author }}</p> -->
                </div>
              </div>
              <span class="leftN anniu" @click="bookLeft"
                ><i class="el-icon-arrow-left"></i
              ></span>
              <span class="rightN anniu" @click="bookRight"
                ><i class="el-icon-arrow-right"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 品牌故事 -->
    <div class="gushi">
      <div class="bg">
        <img src="../../assets/img/5.0/img04.png" alt="">
      </div>
      <div class="pinpai">
        <div class="left">
          <div class="pic">
            <img src="../../assets/img/5.0/img05.png" alt="">
          </div>
        </div>
        <div class="right">
          <h2>品牌故事</h2>
          <h3>ABOUT US</h3>
          <p>瑞鑫教育集团成立于2005年，是一家集教学教研、图书出版、培训服务于一体的综合性教育公司。
            公司始终秉持“全心全意为师生服务”的宗旨，以强烈的社会责任感，倾心提供优质教育服务，致力于打造专业、诚信的教育品牌。
            近年来，公司全力构建教师精准教学教研赋能平台，不断提升教研能力，构建优质的教育生态系统，铸就卓越教学品质，为师生赋予强大能量。
            目前，已服务全国1.4万所高中，30万名教师，800万名学生。
          </p>
          <p>与此同时，瑞鑫点教集团坚定不移地支持公益助教助学事业，持续开展“送教助学公益全国行”。
            联合各省市教研室，陆续开展了数百场“高中跨区域专家协同教研”系列公益活动，促进各地教育理念与经验的深度交流和广泛共享。</p>
            <p>在智能化的时代背景下，点教在AI助教方面携手全国众多权威教育专家，以其卓越智慧和丰富经验，
              借助先进的人工智能技术，精心为广大教师打造智能化的教研教学辅助平台。</p>
          <!-- <div class="xq">了解详情</div>   -->
        </div>
      </div>
    </div>
    <!-- 合作教研室 -->
    <div class="hzjys">
      <div class="boxtitle">
        <div class="left">
          <h4>合作教研室</h4>
        </div>
      </div>
      <div class="picLists">
        <img src="../../assets/img/5.0/1.png" alt="">
        <img src="../../assets/img/5.0/2.png" alt="">
        <img src="../../assets/img/5.0/3.png" alt="">
        <img src="../../assets/img/5.0/4.png" alt="">
        <img src="../../assets/img/5.0/5.png" alt="">
        <img src="../../assets/img/5.0/6.png" alt="">
        <img src="../../assets/img/5.0/7.png" alt="">
        <img src="../../assets/img/5.0/8.png" alt="">
        <img src="../../assets/img/5.0/9.png" alt="">
        <img src="../../assets/img/5.0/10.png" alt="">
        <img src="../../assets/img/5.0/11.png" alt="">
        <img src="../../assets/img/5.0/12.png" alt="">
      </div>
    </div>
    
    <!-- 首次进入网站未有年级科目版本弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
      width="800px"
    >
      <div class="chose">
        <p>1.请选择您所在的年级：</p>
        <div class="tab1 taps">
          <div
            class="classRadio"
            v-for="item in nianjiList"
            :key="item.id"
            @click="radio3 = item.id"
          >
            <div class="tips1 tips" v-if="radio3 != item.id"><span></span></div>
            <div class="tips2 tips" v-if="radio3 == item.id"><span></span></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <p>2.请选择您所教的学科：</p>
        <div class="tab1 taps">
          <div
            class="classRadio"
            v-for="item in classList"
            :key="item.id"
            @click="changeKemu(item.id)"
          >
            <div class="tips1 tips" v-if="radio1 != item.id"><span></span></div>
            <div class="tips2 tips" v-if="radio1 == item.id"><span></span></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <p>3.请选择您所教学科的教学版本：</p>
        <div class="tab2 taps">
          <div
            class="classRadio"
            v-for="item in banbenList"
            :key="item.id"
            @click="radio2 = item.id"
          >
            <div class="tips1 tips" v-if="radio2 != item.id"><span></span></div>
            <div class="tips2 tips" v-if="radio2 == item.id"><span></span></div>
            <p>{{ item.title }}</p>
          </div>
        </div>
        <div class="submitSet" @click="submit">
          <span>提交信息</span>
        </div>
      </div>
    </el-dialog>
    <!-- 更新提醒弹窗 -->
    <gxtxTc
      v-if="gxtxShow"
      @gxtcClose="gxtcClose"
      :zykf_file_url="zykf_file_url"
    >
    </gxtxTc>
  </div>
</template>

<script>
import { timeStamp2String } from "../../utils/time";
import gxtxTc from "../../components/gxtxTc/gxtx.vue"
import {
  banner,
  sjtj,
  nowkemu,
  userinfo,
  zyzxinfo,
  zyzxgs,
  activityindex,
  getbookbyprogress,
  nianjilists,
  kemulists,
  versionslists,
  setnowkemu,
  list_kejian,
  productinfo,
  chapterskejian,
  chapterskejian_new,
  page_times,
  getgoodsweekpopup,
  closepopup,
  groupbuygoodsinfo,
  islogin,
  list_teachers,
  list_zbhd,
  list_starteacherstudio,
  info_kejian,
} from "../../api/http";
export default {
  components: {gxtxTc},
  props: ["xitongMsg", "kefuMsg"],
  metaInfo () {
    return {
      title: '精准教研教学平台-专注教师教研与教学服务，助力教师专业提升！',
       meta: [{ 
        name: 'Keywords',
        content: '教研教学平台,教学资源,同步教研,课件下载,同步课件,备课资源,教师培训,教师研修,人教版课件,在线教研,新高考'
      }, {
        name: 'description',
        content: '精准教研教学平台是一个专门为全国高中教师打造的教研教学服务平台，侧重高中教材同步精品资源下载（课件、教案、学案、试卷、素材、练习等）、体系化公益教研活动直播、专家名师工作室优质资源共享等。精准定位教学需求，助力提升教学水平，是高中教师随时随地的教研教学小助手。'
      }],
    }
  },
  data() {
    return {
      // pageTitle:'精准教研教学平台-专注教师教研与教学服务，助力教师专业提升！',
      dialogTableVisible: false, //提交信息弹窗
      bannerList: [], //banner图表
      bannerList2:[],//资源轮播
      timeStamp2String, //时间戳转时间的函数
      kejianbooks_id: 0, //书本id

      kemu_id: 0, //当前科目id
      nianji_id: 0, //当前年级id
      kejianversions_id: 0, //当前版本id
      kejianchapters_id: 0, //目录id
      


      //首次进入弹窗相关内容
      nianjiList: [], //可选年级列表
      classList: [], //学科列表
      banbenList: [], //版本列表
      radio3: "9", //年级值
      radio1: "1", //学科值
      radio2: "", //版本值

      //4.2版本
      tabvalue: 1, //tab值
      boxLeft: 0, //图片滚动距离
      newLists: [], //最新资源列表
      newshijuanLists: [], //最新资源列表
      activeList: [], //主页活动推荐
      booklist: [], //主页精选产品列表

      
      from_account_id:'',//用户id


      gxtxShow:false,//更新提醒弹窗展示
      zykf_file_url:'',

      teacherLists:[],
      picMoveWidth: 0, //第一种图片位移距离

      msLists:[],//名师工作室列表
      tjzyLists:[],//推荐资源列表
      tjFileMsg:{},
    };
  },
  created() {
    //回到顶部
    $(document).ready(function () {
      $(window).scrollTop(0);
    });
    //不受登录影响的数据
    
    
    this.getproduct(); //获取主页推荐产品
    this.getTeachers(); //获取教师列表
    this.getMsLists(); //获取名师工作室列表
    islogin().then(res=>{
      if(res.retRes.login_status == 1){
        userinfo({
          md5key: localStorage.getItem("md5key"),
        }).then((res) => {
          this.from_account_id = res.retRes.id
          if (res.retInt == 1) {
            // if (res.retInt == 1 && res.retRes.sy_end_time * 1000 > Date.parse(new Date()) ) {
              const data = res.retRes;
              this.nianji_id = data.nianji_id; //当前年级id
              this.radio3 = data.nianji_id; //赋值初次弹窗年级id
              this.kemu_id = data.kemu_id;
              this.radio1 = data.kemu_id; //赋值初次弹窗科目id

              //获取当前科目和版本
              nowkemu({
                md5key: localStorage.getItem("md5key"),
              }).then((res) => {
                if (res.retInt == 1) {
                  const data = res.retRes;
                  this.kejianversions_id = data.kejianversions_id; //当前版本id
                  this.radio2 = data.kejianversions_id; //赋值初次弹窗版本id
                  this.kejianchapters_id = data.kejianchapters_id; //当前目录id
                  this.kejianbooks_id = data.kejianbooks_id; //当前书本id
                  this.kemu_id = data.kemu_id; //当前科目id
                  this.getbanner(); //获取banner
                  this.getnewziyuan(); //获取首页最新资源
                  this.getnewshijuan();//获取首页最新试卷
                  this.getTjzyBanner();//获取首页推荐资源
                  this.getactive(); //获取主页活动列表
                  
                }
              });
            // } 
            // else if (res.retRes.sy_end_time * 1000 < Date.parse(new Date())) {
            //   this.$router.push({
            //     name: "Login",
            //     query: {
            //       isgq: 1,
            //     },
            //   });
            // }
          }
        })
      }else{
        this.kemu_id = localStorage.getItem('tckm')?localStorage.getItem('tckm'):'';
        this.nianji_id = localStorage.getItem('tckm')?localStorage.getItem('tcnj'):'';
        this.kejianversions_id = localStorage.getItem('tckm')?localStorage.getItem('tcbb'):'';
        this.getbanner(); //获取banner
        this.getTjzyBanner();//获取首页推荐资源
        this.getnewziyuan(); //获取首页最新资源
        this.getnewshijuan();//获取首页最新试卷
        this.getactive(); //获取主页活动列表

        if(!localStorage.getItem('tckm')){
          //获取年级列表数据
          nianjilists({ md5key: localStorage.getItem("md5key") }).then(
            (res) => {
              const data = res.retRes;
              if (res.retInt == 1) {
                this.nianjiList = data;
              }
            }
          );
          //获取科目列表
          kemulists({ md5key: localStorage.getItem("md5key") }).then(
            (res) => {
              const data = res.retRes;
              if (res.retInt == 1) {
                this.classList = data;
              }
            }
          );
          setTimeout(() => {
            //获取教学版本列表
            versionslists({
              md5key: localStorage.getItem("md5key"),
              kemu_id: this.radio1 ? this.radio1 : "1",
            }).then((res) => {
              const data = res.retRes;
              if (res.retInt == 1) {
                this.banbenList = data;
              }
            });
          }, 200);
          this.dialogTableVisible = true;
        }
      }
    })

    this.date = new Date(); //获取当前日期
    this.currentMonthCount = new Date(
      this.date.getFullYear(),
      this.date.getMonth() + 1,
      0
    ).getDate(); //获取本月天数
  },
  mounted() {
    //判断当前用户是否需要服务包更新弹窗
    // getgoodsweekpopup({
    //   md5key: localStorage.getItem("md5key"),
    // }).then(res=>{
    //   if(res.retRes == 1){
    //     this.gxtxShow = true
    //     this.zykf_file_url = this.kefuMsg.qwkf_file_url
    //   }
    // })
    //重定向
    localStorage.setItem("path", "");
  },
  methods: {
    //获取名师工作室列表
    getMsLists(){
      list_starteacherstudio().then(res=>{
        this.msLists = res.retRes;
      })
    },
    //关闭更新提醒弹窗
    gxtcClose(){
      this.gxtxShow = false
      closepopup({
        md5key: localStorage.getItem("md5key"),
      })
    },
    //获取主页banner图
    getbanner() {
      banner({
        md5key: localStorage.getItem("md5key"),
        systypes_id: 10010,
        device_type_id: 201,
        kemu_ids:this.kemu_id,
      }).then((res) => {
        if (res.retInt == 1) {
          this.bannerList = res.retRes;
        }
      });
    },
    getTjzyBanner(){
      banner({
        md5key: localStorage.getItem("md5key"),
        systypes_id: 10011,
        device_type_id: 201,
        kemu_ids:this.kemu_id,
      }).then((res) => {
        if (res.retInt == 1) {
          this.bannerList2 = res.retRes;
          let tjidArr = []

          this.bannerList2.forEach(item=>{
            let parts = item.http_url.split('id=');
            let id = parts[1].split('&')[0];
            tjidArr.push(id)
          })
          this.getTjziyuan(tjidArr);//获取首页推荐资源
        }
      });
    },
    bannerGo(url){
       window.open(url, "_blank");
      // let parts = url.split('id=');
      // if (parts.length > 1) {
      //     let id = parts[1].split('&')[0];
      //     info_kejian({
      //       md5key: localStorage.getItem("md5key"),
      //       id: id,
      //     }).then(res=>{
      //       let suffix = res.retRes.suffix
      //       if(suffix != "rar" && suffix != "zip"){
      //         let { href } = this.$router.resolve({
      //           path: "/resource/resDetails",
      //           query: {
      //             id: id,
      //             path: this.$route.path,
      //             routeName: "首页",
      //           },
      //         });
      //         window.open(href, "_blank");
      //       }else if (suffix == "rar" || suffix == "zip") {
      //           let { href } = this.$router.resolve({
      //           path: "/resource/zipResDetails",
      //           query: {
      //             id: id,
      //             path: this.$route.path,
      //             routeName: "首页",
      //           },
      //         });
      //         window.open(href, "_blank");
      //       }
      //     })
      // }
          
      
    },
    //获取首页最新资源
    getnewziyuan() {
      list_kejian({
        md5key: localStorage.getItem("md5key"),
        nianji_ids: this.nianji_id,
        kemu_id: this.kemu_id,
        kejianversions_id: this.kejianversions_id,
        of:"time",
        from_int: 10,
        page_size:5,
      }).then((res) => {
        if (res.retRes.length > 5) {
          this.newLists = res.retRes.slice(0, 5);
        } else {
          this.newLists = res.retRes;
        }
      });
    },
    //获取首页最新试卷
    getnewshijuan() {
      list_kejian({
        md5key: localStorage.getItem("md5key"),
        nianji_ids: this.nianji_id,
        kemu_id: this.kemu_id,
        kejianversions_id: this.kejianversions_id,
        of:"time",
        type_id: 2,
        from_int: 10,
        page_size:5,
      }).then((res) => {
        if (res.retRes.length > 10) {
          this.newshijuanLists = res.retRes.slice(0, 5);
        } else {
          this.newshijuanLists = res.retRes;
        }
      });
    },
    //获取首页推荐资源
    getTjziyuan(num) {
      list_kejian({
        md5key: localStorage.getItem("md5key"),
        nianji_ids: this.nianji_id,
        kemu_id: this.kemu_id,
        kejianversions_id: this.kejianversions_id,
        is_tj:1,
        page_size:num.length + 3,
      }).then((res) => {
        this.tjzyLists = []
        let arr = []
        arr = res.retRes.filter(item => !num.includes(item.id));
        if(arr.length >= 3){
          this.tjzyLists = arr.slice(0,3)
        }else{
          this.tjzyLists = arr
        }
        // res.retRes.forEach(item=>{
        //   if(num.indexOf(item.id) == -1){
        //     this.tjzyLists.push()
        //   }
        // })
          // this.tjzyLists = res.retRes;
          console.log(num,arr,this.tjzyLists)
          // this.tjFileMsg.title = res.retRes[0].title
          // this.tjFileMsg.time = res.retRes[0].update_time
          // this.tjFileMsg.row_id = res.retRes[0].id
          // this.tjFileMsg.suffix = res.retRes[0].suffix
      });
    },
    //主页最新资源查看更多
    gotobu() {
      this.$router.push({
        name: "Newzy",
        query: {
          routeName:'首页',
          path: "/",
          fliter: "zy",
        },
      });
    },
    //主页最新试卷查看更多
    sjseemore() {
      this.$router.push({
        name: "Newzy",
        query: {
          routeName:'首页',
          path: "/",
          fliter: "sj",
        },
      });
    },
    //主页活动推荐列表
    getactive() {
      list_zbhd({
        md5key: localStorage.getItem("md5key"),
        kemu_id:this.kemu_id,
        from_index:1,
      }).then((res) => {
        if (res.retInt == 1) {
          if (res.retRes.length >= 3) {
            this.activeList = res.retRes.slice(0, 3);
          }
        }
      });
    },
    //主页精选产品
    getproduct() {
      productinfo({
        md5key: localStorage.getItem("md5key"),
        // type_id: 1, //默认产品分类为高中语文
      }).then((res) => {
        this.booklist = res.retRes.topbooklist; //顶部精选
      });
    },
    //前往图书详情页
    productDetails(id, type_id) {
      if (type_id == 1) {
        this.$router.push({
          name: "ProductDetails",
          query: {
            id: id,
          },
        });
      } else if (type_id == 2) {
        this.$router.push({
          name: "ClassOnline",
          query: {
            id: id,
          },
        });
      } else if (type_id == 3) {
        this.$router.push({
          name: "JingtingDetails",
          query: {
            id: id,
          },
        });
      }
    },
    gomsrz() {
      this.$router.push({
        name: "Msrz",
        // query: {
        //     id: id,
        // },
      })
    },
    goMsCenter(){
      this.$router.push({
        name: "TecStudio",
      })
    },
    gomsDetails(id) {
      this.$router.push({
        name: "StudioDetails",
        query: {
            id: id,
        },
      })
    },
    //图书轮播左按钮
    bookLeft() {
      const box = this.$refs.booksList;
      const picWidth = 240;
      this.boxLeft += 240;
      box.style.left = this.boxLeft + "px";
      box.style.transition = "all 0.5s ease-in-out";
      console.log(this.boxLeft);
      if (this.boxLeft > 0) {
        box.style.left = -picWidth * (this.booklist.length - 4) + "px";
        this.boxLeft = -picWidth * (this.booklist.length - 4);
      }
    },
    //图书轮播右按钮
    bookRight() {
      const box = this.$refs.booksList;
      const picWidth = 240;
      this.boxLeft -= 240;
      box.style.left = this.boxLeft + "px";
      box.style.transition = "all 0.5s ease-in-out";
      if (this.boxLeft < -(this.booklist.length - 4) * picWidth) {
        box.style.left = 0 + "px";
        this.boxLeft = 0;
      }
    },
    //教师轮播左按钮
    tecLeft() {
      const picWidth = 295;
      this.picMoveWidth += 295;
      let leftN = document.querySelector(".teacherLists");
      leftN.style.left = this.picMoveWidth + "px";
      leftN.style.transition = "all 0.5s ease-in-out";
      this.steep = this.picMoveWidth;
      if (this.picMoveWidth >= 295) {
        setTimeout(() => {
          leftN.style.transition = "left 0s ease-in-out";
          leftN.style.left = -picWidth * (this.teacherLists.length - 1) + "px";
          this.picMoveWidth = -picWidth * (this.teacherLists.length - 1);
          this.steep = -picWidth * (this.teacherLists.length - 1);
        }, 500);
      }
    },
    //教师轮播右按钮
    tecRight() {
      let leftN = document.querySelector(".teacherLists");
      leftN.style.transition = "all 0.5s ease-in-out";
      const picWidth = 295;
      this.picMoveWidth -= 295;
      this.steep = this.picMoveWidth;
      leftN.style.left = this.picMoveWidth + "px";
      // console.log(this.picMoveWidth);
      // console.log(this.picMoveWidth, -picWidth * this.teacherLists.length);
      if (this.picMoveWidth <= -picWidth * this.teacherLists.length) {
        setTimeout(() => {
          leftN.style.transition = "left 0s ease-in-out";
          leftN.style.left = 0 + "px";
          this.picMoveWidth = 0;
          this.steep = 0;
        }, 500);
      }
    },
    //获取教师列表
    getTeachers() {
      list_teachers({
        md5key: localStorage.getItem("md5key"),
      }).then((res) => {
        console.log(res, "教师列表");
        this.teacherLists = res.retRes;
      });
    },
    //跳转广告图
    advert(href,id) {
      page_times({
        md5key: localStorage.getItem("md5key"),
        table_name:'banner',
        row_id:id,
        times:0,
        from_account_id:0
      }).then(

      )
      window.open(href, "_blank");
    },
    //点击课件前往课件详情或课件包详情
    goresDetails(id, lx, suffix) {
      //有分类型，并且类型为备课资源包
      if (lx && lx == 2 && suffix != "rar" && suffix != "zip") {
        let { href } = this.$router.resolve({
          path: "/resource/beikeziyuan",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
        //有分类型，并且类型为课件
      } else if (lx && lx == 1 && suffix != "rar" && suffix != "zip") {
        // console.log("推荐课件")
        let { href } = this.$router.resolve({
          path: "/resource/resDetails",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
        //非推荐，全部为正常课件
      } else if (!lx && suffix != "rar" && suffix != "zip") {
        let { href } = this.$router.resolve({
          path: "/resource/resDetails",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
      } else if (suffix == "rar" || suffix == "zip") {
        let { href } = this.$router.resolve({
          path: "/resource/zipResDetails",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
      }
    },
    //去活动详情
    goActiveDetails(id, type,url) {
      if(type == 1){
        let { href } = this.$router.resolve({
          path: "/active/fullScreen",
          query: {
            id: id,
            type: 'hd',
            from: "index",
          },
        });
        window.open(href, "activeRes");
      }else{
        let href = url
        window.open(href, "activeRes");
      }
    },
    //前往推荐的产品
    goProductDetails(id) {
      this.$router.push({
        name: "ProductDetails",
        query: {
          id: id,
        },
      });
    },
    //前往活动中心
    goActiveCenter() {
      this.$router.push({
        path: "/active",
      });
    },
    //前往资源中心
    goResourceCenter() {
      this.$router.push({
        path: "/product",
      });
    },
    goTb(){
      this.$router.push({
        path: "/resourceTb",
      });
    },
    //前往产品中心
    goProductCenter() {
      this.$router.push({
        path: "/product",
      });
    },
    //前往个人中心
    goPersonalCenter() {
      this.$router.push({
        path: "/personal",
      });
    },
    //前往查看数据统计
    goStatistical() {
      this.$router.push({
        path: "/active",
      });
    },
    //首次弹窗
    //切换科目后，版本会更新为选择的科目版本
    changeKemu(id) {
      this.radio1 = id;
      this.radio2 = "";
      //获取教学版本列表
      versionslists({
        kemu_id: this.radio1,
      }).then((res) => {
        // console.log(res, "版本列表");
        const data = res.retRes;
        if (res.retInt == 1) {
          this.banbenList = data;
        }
      });
    },
    //提交设置的科目和版本
    submit() {
      // console.log(this.radio3, this.radio1, this.radio2);
      if (!this.radio1) {
        this.$message({
          message: "请选择学科",
          duration: 1000,
          showClose: false,
        });
      } else if (!this.radio2) {
        this.$message({
          message: "请选择版本",
          duration: 1000,
          showClose: false,
          offset: 300,
        });
      } else if (!this.radio3) {
        this.$message({
          message: "请选择年级",
          duration: 1000,
          showClose: false,
          offset: 300,
        });
      } else {
        this.kemu_id = this.radio1;
        this.nianji_id = this.radio3;
        this.kejianversions_id = this.radio2;
        this.getbanner(); //获取banner
        this.getTjzyBanner();//获取首页推荐资源
        this.getnewziyuan(); //获取首页最新资源
        this.getnewshijuan();//获取首页最新试卷
        this.getactive(); //获取主页活动列表
        localStorage.setItem('tckm',this.kemu_id)
        localStorage.setItem('tcnj',this.nianji_id)
        localStorage.setItem('tcbb',this.kejianversions_id)
        this.dialogTableVisible = false;
      }
    },
    //我知道了
    reday() {
      this.$router.push({
        name: "home",
      });
    },
  },
};
</script>
<style>

</style>
<style lang="less" scoped>
#container {
  margin-bottom: 20px;
  min-height: 54vh;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  .bigBanner {
    display: flex;
    margin: 0 auto;
    margin-top: 20px;
    width: 1200px;
    .banner {
      margin: 0px auto;
      margin-right: 10px;
      width: 1200px;
      .el-carousel {
        width: 100%;
        height: 100%;
        // border-radius: 20px;
        .el-carousel__item {
          width: 100%;
          height: 100%;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            // vertical-align: text-bottom;
            color: #000;
          }
        }
      }
    }
  }
  .jyactive {
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 1200px;
    background: #ffffff;
    border-radius: 10px;
    .boxtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .left {
        margin: 19px;
        margin-bottom: 15px;
        h4 {
          margin-right: 5px;
          font-size: 18px;
          color: #333;
        }
      }
      .right {
        margin-right: 17px;
        font-size: 12px;
        color: #999;
        cursor: pointer;
      }
      .right:hover {
        color: #1E60EB;
      }
    }
    .activeList {
      display: flex;
      position: relative;
      padding-bottom: 20px;
      margin-left: 20px;
      .activeBox {
        position: relative;
        margin-right: 20px;
        cursor: pointer;
        .tips{
            position: absolute;
            left: 10px;
            top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            height: 20px;
            background: #000000;
            border-radius: 4px;
            opacity: 0.9;
            color: #FFFFFF;
            text-align: center;
            line-height: 20px;
            img{
              margin-right: 4px;
            }
          }
          .zbz{
            color: #FFFFFF;
            background: #F05659;
          }
        .pic {
          img {
            width: 275px;
            max-height: 146px;
            border-radius: 0px;
          }
        }
        .activetitle {
          margin-top: 4px;
          p {
            font-size: 14px;
            color: #333;
            width: 275px;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2; // 控制多行的行数
            -webkit-box-orient: vertical;
          }
        }
        .teacherName{
          // position: absolute;
          // bottom: 20px;
          margin-top: 4px;
          font-size: 12px;
          color: #939599;
        }
        .activetime {
          position: absolute;
          bottom: 8px;
          font-size: 12px;
          color: #939599;
        }
        .dosome {
          position: absolute;
          bottom: 2px;
          right: 0;
          text-align: center;
          line-height: 28px;
          font-size: 12px;
          color: #fff;
          width: 80px;
          height: 28px;
          // background: #f05659;
          border-radius: 14px;
          cursor: pointer;
        }
        .bm {
          background: #1E60EB;
        }
        .zhibo {
          background: #f05659;
        }
        .huifang {
          background: #c4c7cc;
        }
      }
      .activeBox:hover {
        // transition: 1s;
        img {
          transition: 0.5s;
          // position: relative;
          // top: -10px;
          transform: translateY(-10px);
          box-shadow: 0px 2px 10px 2px #dedede;
        }
        .activetitle {
          transition: 0.5s;
          transform: translateY(-10px);
          p {
            color: #1E60EB;
          }
        }
        .teacherName{
          transition: 0.5s;
          transform: translateY(-10px);
        }
      }
      .seemoreactive {
        position: relative;
        // right: 20px;
        // position: absolute;
        margin-right: 20px;
        width: 275px;
        border-radius: 10px;
        overflow: hidden;
        img {
          width: 275px;
          border-radius: 10px;
        }
        .gomoreactive {
          position: absolute;
          left: 50%;
          bottom: 30px;
          transform: translateX(-50%);
          text-align: center;
          line-height: 40px;
          width: 200px;
          height: 40px;
          background: #1E60EB;
          border-radius: 6px;
          font-size: 12px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
  .teschers {
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 1200px;
    background: #ffffff;
    border-radius: 10px;
    .boxtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .left {
        margin: 19px;
        margin-bottom: 15px;
        h4 {
          margin-right: 5px;
          font-size: 18px;
          color: #333;
        }
      }
      .right {
        margin-right: 17px;
        font-size: 12px;
        color: #999;
        cursor: pointer;
      }
      .right:hover {
        color: #1E60EB;
      }
    }
    .recommend {
      margin-left: 20px;
      margin-bottom: 20px;
      .tecLists {
        display: flex;
        height: 320px;
        .tecSwiper {
          position: relative;
          width: 1160px;
          overflow: hidden;
          .teacherLists {
            display: flex;
            position: absolute;
            left: 0;
            // width: 24000px;
            // white-space: nowrap;
            .box {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-left: 20px;
              width: 275px;
              height: 320px;
              // cursor: pointer;
              background: #F5F5F5;
              img {
                margin-top: 40px;
                // width: 100px;
                width: 120px;
                height: 120px;
                object-fit: cover;
                border-radius: 50%;
              }
              
              h3{
                margin-top: 22px;
                font-size: 18px;
                color: #333333;
                line-height: 34px;
              }
              h4 {
                margin-top: 4px;
                font-size: 14px;
                color: #333333;
                font-weight: normal;
              }
              p {
                margin: 0 auto;
                margin-top: 20px;
                width: 228px;
                margin-top: 10px;
                font-size: 12px;
                color: #333333;
                // text-align: center;
                font-weight: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; // 控制多行的行数
                -webkit-box-orient: vertical;
              }
            }
            .box:hover {
              h4 {
                // color: #1E60EB;
              }
            }
            .box:first-child{
              margin-left: 0;
            }
          }
          .anniu {
            position: relative;
            display: inline-block;
            line-height: 62px;
            width: 34px;
            height: 62px;
            background: #000000;
            opacity: 0.5;
            color: #fff;
            font-size: 18px;
            text-align: center;
            cursor: pointer;
          }
          .leftN {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            // border-radius: 0px 18px 18px 0px;
            i {
              margin-right: 2px;
            }
          }
          .rightN {
            position: absolute;
            transform: translateY(-50%);
            top: 50%;
            right: 0;
            // border-radius: 18px 0px 0px 18px;
            i {
              margin-left: 2px;
            }
          }
        }
      }
    }
    .gongzuoshi{
      display: flex;
      flex-wrap: wrap;
      .gzsBox{
        display: flex;
        align-items: center;
        // justify-content: center;
        margin-left: 20px;
        margin-bottom: 20px;
        width: 566px;
        height: 220px;
        background: #FFFFFF;
        border: 2px solid #F5F5F5;
        .left{
          position: relative;
          display: flex;
          // align-items: center;
          padding-right: 20px;
          margin-left: 30px;
          width: 235px;
          height: 180px;
          border-right: 1px solid #E6E6E6;
          .pic{
            position: relative;
            margin-top: 20px;
            width: 88px;
            height: 88px;
            border-radius: 50%;
            overflow: hidden;
            box-shadow: -10px 0px 0px 1px #F5F5F5; 
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
            }
          }
          .msg{
            margin-top: 26px;
            margin-left: 15px;
            h4{
              font-size: 16px;
              color: #333333;
            }
            p{
              margin: 4px 0 10px 0;
              font-size: 14px;
              color: #999999;
            }
            .zylj{
              font-size: 14px;
              color: #999999;
              span{
                color: #F6444E;
              }
            }
            
          }
          .tip{
            position: absolute;
            bottom: 32px;
            left: -6px;
            padding: 0 10px;
            font-size: 14px;
            color: #666666;
            line-height: 24px;
            min-width: 80px;
            height: 24px;
            background: #F5F5F5;
            border-radius: 12px;
            border: 1px solid #CCCCCC;
            text-align: center;
          }
        }
        .right{
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 285px;
          .fileList{
            position: relative;
            display: flex;
            // align-items: center;
            width: 285px;
            height: 80px;
            
            .pic{
              margin-left: 16px;
              margin-top: 10px;
              width: 44px;
              height: 48px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .msg{
              margin-left: 14px;
              h4{
                margin-top: 10px;
                margin-bottom: 20px;
                width: 200px;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; // 控制多行的行数
                -webkit-box-orient: vertical;
              }
              p{
                position: absolute;
                right: 20px;
                bottom: 10px;
                color: #999999;
                font-size: 12px;
              }
            }
          }
          .fileList:hover{
            background: #F5F5F5;
            .msg{
              h4{
                color: #1E60EB;
              }
            }
          }
          p{
            font-size: 12px;
            color: #999999;
          }
        }
      }
      .gzsBox:hover{
        box-shadow: 0px 0px 10px 0px rgba(15,51,126,0.2);
        cursor: pointer;
        .left{
          .pic{
            box-shadow: -10px 0px 0px 1px #1E60EB; 
          }
          .tip{
            position: absolute;
            bottom: 32px;
            left: -6px;
            padding:0 10px;
            font-size: 14px;
            color: #1E60EB;
            line-height: 24px;
            min-width: 80px;
            height: 24px;
            background: #EFF3FA;
            border-radius: 12px;
            border: 1px solid #1E60EB;
            text-align: center;
          }
        }
        .right{
          p{
            color: #1E60EB;
          }
        }
      }
    }
    .msBanner{
      position: relative;
      display: flex;
      justify-content: center;
      
      width: 1200px;
      .pic{
        margin-bottom: 20px;
        width: 1160px;
        height: 148px;
        background: #1A449C;
      }
      .msru{
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        width: 140px;
        height: 28px;
        background: #1E60EB;
        border-radius: 14px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .ziyuanTj{
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 1200px;
    background: #ffffff;
    border-radius: 10px;
    .boxtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-bottom: 10px;
      .left {
        margin: 19px;
        margin-bottom: 15px;
        h4 {
          margin-right: 5px;
          font-size: 18px;
          color: #333;
        }
      }
      .right {
        margin-right: 17px;
        font-size: 12px;
        color: #999;
        cursor: pointer;
      }
      .right:hover {
        color: #1E60EB;
      }
    }
    .tjBox{
      display: flex;
      .banner {
        position: relative;
        margin-left: 20px;
        margin-right: 20px;
        width: 580px;
        .el-carousel {
          width: 580px;
          height: 100%;
          // border-radius: 20px;
          .el-carousel__item {
            width: 100%;
            height: 100%;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              // vertical-align: text-bottom;
              color: #000;
            }
          }
        }
        h2{
          position: absolute;
          top: 70px;
          left: 40px;
          width: 480px;
          color: #FFF;
          font-size: 32px;
          z-index: 1000;
          cursor: pointer;
        }
        p{
          position: absolute;
          bottom: 100px;
          left: 40px;
          color: #FFF;
          font-size: 18px;
          // font-weight: 900;
          z-index: 1000;
          cursor: pointer;
        }
      }
      .right{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 578px;
        border-top: 1px solid #E1E2E5;
        .zyLists{
          display: flex;
          align-items: center;
          border-bottom: 1px solid #E1E2E5;
          .left{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-right: 20px;
            margin-left: 20px;
            height: 60px;
            border-right: 1px solid #E1E2E5;
            h2{
              font-size: 24px;
              color: #666666;
            }
            p{
              font-size: 18px;
              color: #999999;
            }
          }
          .zyright{
            position: relative;
            display: flex;
            // align-items: center;
            margin-left: 28px;
            height: 100px;
            cursor: pointer;
            .pic{
              margin-top: 26px;
              margin-right: 14px;
              width: 44px;
              height: 48px;
              img{
                width: 100%;
                height: 100%;
              }
            }
            .msg{
              margin-top: 30px;
              h4{
                width: 340px;
                font-size: 14px;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; // 控制多行的行数
                -webkit-box-orient: vertical;
                font-weight: 400;
              }
            }
            p{
              position: absolute;
              bottom: 16px;
              right: 10px;
              font-size: 14px;
              color: #1E60EB;
            }
          }
        }
        
      }
    }
    .ziyuan {
      display: flex;
      justify-content: space-between;
      margin: 20px auto;
      margin-bottom: 10px;
      width: 1200px;
      .newziyuan {
        width: 590px;
        // height: 160px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        .boxtitle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left {
            display: flex;
            align-items: center;
            margin: 19px;
            margin-bottom: 15px;
            h4 {
              margin-right: 5px;
              font-size: 18px;
              color: #333;
            }
            span {
              font-weight: 600;
              font-size: 14px;
              color: #f6444e;
            }
          }
          .right {
            margin-right: 15px;
            font-size: 12px;
            color: #999;
            cursor: pointer;
          }
          .right:hover {
            color: #1E60EB;
          }
        }
        .ziyuancontent {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          // margin-bottom: 15px;
          .ziyuanLists {
            display: flex;
            align-items: center;
            // margin-right: 22px;
            line-height: 32px;
            cursor: pointer;
            img {
              margin-left: 20px;
              margin-right: 5px;
              width: 18px;
              height: 22px;
            }
            p {
              width: 400px;
              color: #333;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1; // 控制多行的行数
              -webkit-box-orient: vertical;
            }
            .zytime {
              margin-left: 65px;
              color: #999;
            }
          }
          .ziyuanLists:hover {
            p {
              color: #1E60EB;
            }
            .zytime {
              color: #1E60EB;
            }
          }
        }
      }
    }
    .product {
      margin: 0 auto;
      padding-bottom: 20px;
      margin-bottom: 20px;
      width: 1200px;
      background: #ffffff;
      border-radius: 10px;
      .boxtitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          margin: 19px;
          margin-bottom: 15px;
          h4 {
            margin-right: 5px;
            font-size: 18px;
            color: #333;
          }
        }
        .right {
          margin-right: 17px;
          font-size: 12px;
          color: #999;
          cursor: pointer;
        }
        .right:hover {
          color: #1E60EB;
        }
      }
      .recommend {
        margin-left: 20px;
        .jiaofuBooks {
          display: flex;
          .tips {
            width: 220px;
            height: 260px;
            // background-image: url("../../assets/img/product_jx.png");
            img {
              width: 220px;
              height: 260px;
              object-fit: cover;
            }
            text-align: center;
            overflow: hidden;
          }
          .bookSwiper {
            position: relative;
            width: 960px;
            overflow: hidden;
            .booksList {
              display: flex;
              position: absolute;
              left: 0;
              // width: 24000px;
              // white-space: nowrap;
              .box {
                width: 240px;
                height: 260px;
                text-align: center;
                cursor: pointer;
                img {
                  margin-top: 30px;
                  // width: 100px;
                  height: 133px;
                  object-fit: cover;
                }
                h4 {
                  margin: 0 auto;
                  width: 156px;
                  margin-top: 10px;
                  font-size: 14px;
                  text-align: center;
                  font-weight: normal;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2; // 控制多行的行数
                  -webkit-box-orient: vertical;
                }
                p {
                  margin-top: 15px;
                  color: #939599;
                  font-size: 12px;
                }
              }
              .box:hover {
                h4 {
                  color: #1E60EB;
                }
              }
            }
            .anniu {
              display: inline-block;
              width: 25px;
              height: 35px;
              background: #000000;
              opacity: 0.3;
              color: #fff;
              font-size: 18px;
              line-height: 33px;
              text-align: center;
              cursor: pointer;
            }
            .leftN {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              border-radius: 0px 18px 18px 0px;
              i {
                margin-right: 2px;
              }
            }
            .rightN {
              position: absolute;
              transform: translateY(-50%);
              top: 50%;
              right: 0;
              border-radius: 18px 0px 0px 18px;
              i {
                margin-left: 2px;
              }
            }
          }
        }
      }
    }
  }
  .gushi{
    width: 100%;
    .bg{
      img{
        width: 100%;
      }
    }
    .pinpai{
      position: relative;
      display: flex;
      margin: 0 auto;
      margin-top: -90px;
      width: 1200px;
      height: 340px;
      background: #FFF;
      z-index: 2;
      .left{
        margin: 40px;
        .pic{
          width: 260px;
          height: 260px;
          background: #CCC;
        }
      }
      .right{
        position: relative;
        margin-top: 40px;
        width: 830px;
        h2{
          font-weight: bold;
          font-size: 24px;
          color: #333333;
        }
        h3{
          margin: 4px 0 10px 0;
          font-size: 18px;
          color: #B3B3B3;
        }
        p{
          margin-bottom: 8px;
          text-indent: 2em;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
        }
        .xq{
          position: absolute;
          right: 10px;
          width: 140px;
          height: 40px;
          border: 1px solid #666666;
          color: #666666;
          font-size: 14px;
          text-align: center;
          line-height: 40px;
          cursor: pointer;
        }
      }
    }
  }
  
  .hzjys {
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 1200px;
    background: #ffffff;
    border-radius: 10px;
    .boxtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .left {
        margin: 19px;
        margin-bottom: 15px;
        h4 {
          margin-right: 5px;
          font-size: 18px;
          color: #333;
        }
      }
    }
    .picLists{
      display: flex;
      flex-wrap: wrap;
      img{
        margin-left: 20px;
        margin-bottom: 20px;
        width: 176px;
        height: 96px;
        background: #CCC;
      }
    }
  }
  //首次弹出框的样式
  .chose {
    position: relative;
    margin-top: 80px;
    margin-left: 40px;
    cursor: pointer;
    p {
      margin: 20px 0;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
      color: #646566;
      color: #333;
    }
    .taps {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 40px;
      .classRadio {
        display: flex;
        margin-right: 60px;
        p{
          font-weight: normal;
          color: #333;
          font-size: 14px;
        }
        .tips {
          position: relative;
          top: 2px;
          margin-right: 8px;
          width: 14px;
          height: 14px;
          border: 1px solid #cccccc;
          border-radius: 100%;
          line-height: 12px;
          text-align: center;
          span {
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 9px;
            height: 9px;
            background-color: #fff;
            border-radius: 100%;
          }
        }
        .tips2 {
          border: 1px solid #1E60EB;

          span {
            background-color: #1E60EB;
          }
        }
        p {
          margin: 0;
        }
      }
    }
    .tab2 {
      .classRadio {
        margin-bottom: 10px;
      }
    }
    .submitSet {
      margin: 0 auto;
      margin-top: 40px;
      // position: absolute;
      // right: 20px;
      // bottom: -80px;
      width: 120px;
      height: 40px;
      background: #1E60EB;
      color: #fff;
      border-radius: 6px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
  }
  /deep/.el-dialog--center {
    border-radius: 10px;
    // padding-bottom: 80px;
    background-image: url('../../assets/img/5.0/msgTc.png');
    background-size:100% ;
    background-repeat: no-repeat;
  }
  /deep/.el-dialog__header {
    padding: 0;
    
  }
  //首页更新提醒弹窗
  .upDateBox {
    position: relative;
    h3 {
      margin-bottom: 30px;
      font-size: 16px;
      text-align: center;
      color: #333;
    }
    p {
      margin: 0 auto;
      font-size: 12px;
      width: 400px;
      line-height: 20px;
      color: #666;
    }
    .pic {
      margin-top: 40px;
      display: flex;
      justify-content: space-around;
      .evm {
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        width: 120px;
        img {
          margin-bottom: 20px;
          width: 120px;
          height: 120px;
        }
        p {
          text-align: center;
        }
      }
    }
    .liaojie {
      position: absolute;
      right: 20px;
      bottom: -80px;
      width: 120px;
      height: 36px;
      background-color: #1E60EB;
      text-align: center;
      color: #fff;
      line-height: 36px;
      font-size: 14px;
      border-radius: 10px;
    }
  }
}
</style>
